import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, className = "", lineClassName = "", baseDelay = 0.15 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: baseDelay + i * 0.14 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <p className={`text-xs font-mono uppercase tracking-[0.25em] ${dark ? "text-purple-300" : "text-purple-700"}`}>
      {children}
    </p>
  );
}

export function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden py-6 border-y ${dark ? "border-white/10 bg-obsidian text-purple-100" : "border-purple-100 bg-background text-purple-950"}`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 shrink-0">
                <span className="font-serif italic text-2xl sm:text-3xl whitespace-nowrap">{item}</span>
                <span className="text-gold text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
